<sigepe-main-layout [showNotifications]="showNotifications" class="template-base" remove-wrapper>
	<div slot-main style="max-width: 1440px; margin: 0 auto">
		<router-outlet></router-outlet>
	</div>
</sigepe-main-layout>
